import { ViewerTabTableColumn, TableCell } from 'components/viewers/ViewerTabTable/types'
import { IconProject, IconBrand, IconCart, IconTicket, IconTime } from 'assets'

export enum TotalSpendColEnums {
  BRAND = 'Brand',
  // DESCRIPTION = 'Description',
  PROJECT = 'Project',
  QUANTITY = 'Qty',
  PRICE = 'Total Price',
  ADDED_AT = 'Added At'
  // PRODUCT = 'Product',
  // TAGS = 'Tag'
}

export const totalSpendColumns: {
  [key in TotalSpendColEnums]: ViewerTabTableColumn<TotalSpendColEnums>
} = {
  [TotalSpendColEnums.BRAND]: {
    label: TotalSpendColEnums.BRAND,
    icon: IconBrand,
    sortable: false,
    width: '30%'
  },
  // [TotalSpendColEnums.DESCRIPTION]: {
  //   label: TotalSpendColEnums.DESCRIPTION,
  //   icon: IconList,
  //   sortable: false,
  //   width: '12%'
  // },
  [TotalSpendColEnums.PROJECT]: {
    label: TotalSpendColEnums.PROJECT,
    icon: IconProject,
    sortable: false,
    width: '30%'
  },
  [TotalSpendColEnums.QUANTITY]: {
    label: TotalSpendColEnums.QUANTITY,
    icon: IconCart,
    sortable: false,
    width: '10%',
    style: { justifyContent: 'center' }
  },
  [TotalSpendColEnums.PRICE]: {
    label: TotalSpendColEnums.PRICE,
    icon: IconTicket,
    sortable: true,
    width: '10%',
    style: { justifyContent: 'center' }
  },
  [TotalSpendColEnums.ADDED_AT]: {
    label: TotalSpendColEnums.ADDED_AT,
    icon: IconTime,
    sortable: false,
    width: '20%',
    style: { justifyContent: 'flex-end' }
  }
}

export type TotalSpendLineInfo = {
  [key in TotalSpendColEnums]: TableCell
} & {
  children?: TotalSpendLineInfo[]
}

// export const getTotalSpendRows = (orders: Order[] = []): LineInfo[] => {
//   return orders.map(order => ({
//     [TotalSpendColEnums.PRODUCT]: { text: order.product, image: order.image },
//     [TotalSpendColEnums.PROJECT]: { text: order.project },
//     [TotalSpendColEnums.BRAND]: { text: order.brand },
//     [TotalSpendColEnums.DESCRIPTION]: { text: 'attribute name' },
//     [TotalSpendColEnums.QUANTITY]: { text: order.count },
//     [TotalSpendColEnums.PRICE]: { text: order.priceAsString },
//     [TotalSpendColEnums.ADDED_AT]: { text: order.dateAsString },
//     [TotalSpendColEnums.TAGS]: { tags: order.tags }
//   }))
// }
